










import { defineComponent } from '@vue/composition-api';
import Strip from '@/components/Strip/index.vue';

export default defineComponent({
    name: 'AddressStrip',
    components: {
        Strip,
    },
    props: {
        value: String,
    },
    setup(props, ctx) {
        const handleClick = () => {
            if (props.value) {
                ctx.root.$go('/address/list?type=select');
            } else {
                ctx.root.$go('/address/add?type=select');
            }
        };
        return { handleClick };
    },
});
